<template>
  <PullRefresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
    <div v-if="startTime != day" :class="`${$style.pageContent}`">
      <div :class="$style.rankList">
        <div :class="$style.timeSelect" id="rankListHeaderTop">
          <div :class="$style.left" @click="onHandleDate('LEFT')">
            <img :src="`${CDN_URL_1}/box_win/l.png`" />前一天
          </div>
          <div :class="$style.date" @click="showDate = true">
            <img :src="`${CDN_URL_1}/box_win/calendar.png`" />
            {{ currentDateTime }}
          </div>
          <div :class="$style.right" @click="onHandleDate('RIGHT')">
            后一天<img :src="`${CDN_URL_1}/box_win/r.png`" />
          </div>
        </div>
        <div :class="$style.game">参与游戏：《{{ gameName }}》</div>
        <div :class="$style.header">
          <h3 :class="$style.title">
            当天您的夺宝点：<span>{{ point }}</span>
          </h3>
        </div>
        <div :class="$style.listItemOne">
          <div :class="$style.ranking">排名</div>
          <div :class="$style.name">用户名</div>
          <div :class="$style.point">夺宝点</div>
        </div>
        <div v-for="item in rankList" :key="item.uid" :class="$style.listItem">
          <div v-if="item.ranking <= 3" :class="$style.ranking">
            <img :src="rankIcon[item.ranking]" />
          </div>
          <div v-if="item.ranking > 3" :class="$style.ranking">
            {{ item.ranking }}
          </div>
          <div :class="$style.name">{{ item.userName }}</div>
          <div :class="$style.point">{{ item.point }}</div>
        </div>
      </div>
      <ActionSheet title="日期选择" v-model="showDate">
        <DatetimePicker
          v-model="dateValue"
          type="date"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="onConfirm"
          @cancel="onCancel"
        />
      </ActionSheet>
    </div>
    <div v-else :class="$style.empty">暂无历史数据~</div>
  </PullRefresh>
</template>

<script>
import { CDN_URL_1 } from "@/config";
import { setPageTitle, toLogin, setRightTxt, phoneBackButtonListener } from "@/bridge/AppJsBridge";
import { PullRefresh, DatetimePicker, ActionSheet } from "vant";
import { getCookie } from "@/libs/utils";
import {
  getWinTreasureRankApi,
  getWinTreasureInfoApi,
} from "@/apis/wxActivity";
import { burnPoint } from "@/apis/heziShare";
import moment from "moment";
import { debounce } from "lodash";

let isDatetimePicker = false;

export default {
  name: "",
  components: {
    PullRefresh,
    DatetimePicker,
    ActionSheet,
  },
  data() {
    return {
      CDN_URL_1: CDN_URL_1,
      activityId: "",
      gameId: "",
      gameName: "",
      point: 0,
      isLoading: false,
      cookie: null,
      rankIcon: {
        1: `${CDN_URL_1}/box_win/3.png`, // 第一名
        2: `${CDN_URL_1}/box_win/4.png`, // 第二名
        3: `${CDN_URL_1}/box_win/5.png`, // 第三名
      },
      rankList: [],
      currentDate: new moment(new Date()).subtract(1, "d"),
      dateValue: new Date(new moment(new Date()).subtract(1, "d")),
      showDate: false,
      isDatetimePicker: false,
      startTime: "",
      endTime: "",
      day: new moment().format("YYYY-MM-DD"),
    };
  },
  created() {
    this.initPageData();
    this.onScrollHeader();
    try {
      phoneBackButtonListener((data, callBack) => {
        callBack('0')
      });
    } catch (error) {
      console.log("error:", error)
    }
  },
  watch: {
    currentDate(newVal, oldVal) {
      !isDatetimePicker && this.onChangeDate();
    },
  },
  activated() {
    // setRightTxt("");
  },
  computed: {
    currentDateTime: function () {
      let time = new moment(this.currentDate).format("YYYY-MM-DD");
      return time;
    },
    minDate: function () {
      let time = new Date(this.startTime);
      return time;
    },
    maxDate: function () {
      let time = new Date(this.endTime);
      return time;
    },
  },
  methods: {
    // 调整页面滚动位置
    onScrollHeader(){
      this.$nextTick(() => {
        setTimeout(() => {
          document.getElementById("rankListHeaderTop").scrollIntoView();
        }, 200);
      })
    },

    // 下拉刷新
    async onRefresh() {
      await this.initPageData();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    // 数据上报
    eventTrack(data) {
      // this.$toast(data.event);
      console.log("正常数据上报", data.event);
      burnPoint({
        ...this.cookie,
        ...data,
      }).catch((err) => console.log(err));
    },

    // 获取缓存等携带的用户信息数据
    async initPageData() {
      const { history } = this.$router;
      const { query } = history.current;
      if (!query.activityId) {
        return;
      }
      setPageTitle("历史夺宝榜单");
      setRightTxt("");
      this.gameId = query.gameId;
      this.activityId = query.activityId;
      const pageCookie = getCookie();
      if (pageCookie) {
        for (const key in pageCookie) {
          if (
            Object.hasOwnProperty.call(pageCookie, key) &&
            pageCookie[key] === "null"
          ) {
            delete pageCookie[key];
          }
        }
        this.cookie = pageCookie;
      }
      // 获取token
      this.getAppToken();
    },

    // 获取登录态
    getAppToken() {
      if (getCookie("token")) {
        localStorage.setItem("token", getCookie("token"));
        this.getRankList();
        this.getActivityInfo();
      } else {
        toLogin("/loginKey/LoginByKeyPhoneActivity");
      }
    },

    getActivityInfo() {
      getWinTreasureInfoApi().then((res) => {
        const { data } = res;
        this.startTime = new moment(data.startTime).format("YYYY-MM-DD");
        this.endTime = this.currentDate.format("YYYY-MM-DD");
      });
    },

    // 游戏榜单
    getRankList(date) {
      if (!date) {
        date = this.currentDate.format("YYYY-MM-DD");
      } else {
        date = new moment(date).format("YYYY-MM-DD");
      }
      getWinTreasureRankApi({
        activeId: this.activityId,
        gameId: this.gameId,
        date,
      }).then((res) => {
        if (!res.data) {
          this.rankList = [];
          return;
        }
        let { rankList = [], gameName, point } = res.data;
        this.rankList = rankList;
        this.gameName = gameName;
        this.point = point;
      });
    },

    onConfirm(date) {
      isDatetimePicker = true;
      this.currentDate = date;
      this.getRankList(date);
      this.onCancel();
    },

    onCancel() {
      this.showDate = false;
    },

    // 操作日期
    onHandleDate(type) {
      let time = new moment(this.currentDate);
      let formatTime = time.format("YYYY-MM-DD");
      isDatetimePicker = false;
      if (type == "LEFT") {
        if (formatTime == this.startTime) {
          this.$toast("已是最前一天");
          return;
        }
        time = time.subtract(1, "d");
        this.dateValue = new Date(time.format("YYYY-MM-DD"));
        this.currentDate = time;
      }
      if (type == "RIGHT") {
        if (formatTime == this.endTime) {
          this.$toast("已是最后一天");
          return;
        }
        time = time.add(1, "d");
        this.dateValue = new Date(time.format("YYYY-MM-DD"));
        this.currentDate = time;
      }

      // this.getRankList(time);
    },
    onChangeDate: debounce(function () {
      this.getRankList(this.currentDate);
    }, 1000),
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="scss" module>
.pageContent {
  width: 100%;
  min-height: 100vh;
  max-width: 375px;
  margin: auto;
  overflow: auto;
  background-size: cover;
  background: #f6f6f6;
  position: relative;
  .rankList {
    background: #ffffff;
    border-radius: 7px;
    margin: 6px 0;
    min-height: 740px;
    padding: 12px 24px;

    .game {
      text-align: center;
      color: #000000;
      font-weight: 700;
      font-size: 16px;
    }
    .header {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      padding-bottom: 4px;
      margin-top: 16px;
      h3 {
        font-size: 15px;
        font-weight: 400;
        text-align: center;
        color: #000000;
        line-height: 16px;
        padding-left: 5px;
      }
      .title::before {
        content: " ";
        width: 3px;
        height: 18px;
        line-height: 18px;
        background: linear-gradient(
          0deg,
          rgba(250, 209, 38, 1) 0%,
          #ff544f 100%
        );
        display: inline-block;
        position: absolute;
        left: 75px;
      }

      .title span {
        color: #ff6d6d;
      }
    }
    .listItem,
    .listItemOne {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 12px;
      div {
        color: #464646;
        font-weight: 500;
        text-align: left;
        font-size: 14px;
      }
      .ranking {
        width: 60px;
        text-align: center;
        img {
          width: 24px;
        }
      }
      .name {
        width: 160px;
        text-align: center;
      }
      .point {
        width: 60px;
        text-align: center;
      }
    }
    .listItemOne div {
      color: #888888 !important;
    }

    .timeSelect {
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 30px;
      margin-bottom: 6px;
      .left {
        display: flex;
        align-items: center;
        font-size: 15px;
        img {
          width: 13px;
          margin-right: 6px;
        }
      }
      .right {
        display: flex;
        align-items: center;
        font-size: 15px;
        img {
          width: 13px;
          margin-left: 6px;
        }
      }
      .date {
        display: flex;
        align-items: center;
        img {
          width: 14px;
          display: inline-block;
          margin-right: 6px;
        }
      }
    }
  }
}

.empty {
  text-align: center;
  margin-top: 50%;
}
</style>
